export const TRANSCRIPTIONS_CONSTS = {
    UPDATE_TRANSCRIPTION: 'UPDATE_TRANSCRIPTION',
    TRANSCRIPTION_DOWNLOAD: 'TRANSCRIPTION_DOWNLOAD',
};
